<template>
  <div class="header-view" @mouseenter="clearTimeout" >
    <div class="content-view">
      <!--左侧图标 -->
      <div class="logo-img"
           @click="goMain()">
        <!-- <img src="../../assets/img/baoma-logo.png" /> -->
        <img src="../../assets/img/BMW_Grey-Colour_RGB3.png" alt="" />
        <div class="title">{{ $t('brand.lg')}}</div>

      </div>
      <div class="tab-content">
        <div class="header-tit">
          <!-- {{ $t('brand.lg')}} &nbsp;&nbsp;<span style="font-family:BMWGlobalProBold;font-weight:normal;"> BMW JOY Learning</span> -->
        </div>
        <template v-if="!hasLogin">
          <div class="each-tab"
               v-for="item in tabs"
               :key="item.dictName"
               :class="[item.color,{active:tabName == item.dictName}]"
               @click="goTab(item,$event)">{{ $t(item.title) }}</div>
        </template>
        <!-- <div class="each-tab yellow">
                  {{$t('headerMenu.information')}}
                </div>
                <div class="each-tab blue">
                  {{$t('headerMenu.addBEST')}}
                </div>
                <div class="each-tab green">
                  {{$t('headerMenu.academicHorizon')}}
                </div>
                <div class="each-tab orange">
                  {{$t('headerMenu.addBMW')}}
        </div> -->
        <template v-if="hasLogin">
          <div class="each-tab"
               v-for="(item, index) in loginMenu"
               :key="index"
               :class="[colorList[index],{active:tabName == item.dictName}]"
               @click="goTab(item,$event)">{{$t(item.dictName)}}</div>
        </template>
        <!-- <div class="each-tab orange"
                     :class="{active:tabName == 'person'}"
                     @click="goPerson(manageBtn,$event)"
                     v-if="hasLogin">
                  {{$t('headerMenu.person')}}
                </div>
                <div class="each-tab brown"
                     :class="{active:tabName == 'manageMain'}"
                     @click="goTab(manageBtn,$event)"
                     v-if="hasLogin">
                  {{$t('headerMenu.manage')}}
        </div>-->
      </div>

      <!-- <div v-for="item in tabs" :key="item.name" class="each-menu" :class="{active:tabName == item.name}" @click="goTab(item,$event)">
              {{ $t(item.title) }}
      </div>-->

      <div class="login" @mousedown="checkKeydown">
        <div class="language"
             v-show="false">
          <el-menu class="aui-navbar__menu"
                   mode="horizontal">
            <el-menu-item index="1">
              <el-dropdown placement="bottom"
                           :show-timeout="0">
                <div size="mini">
                  <svg aria-hidden="true"
                       class="icon-svg">
                    <use xlink:href="#icon-earth" />
                  </svg>
                </div>
                <!-- &nbsp; | &nbsp;{{ $t('_lang') }}</div> -->
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item v-for="(val, key) in i18nMessages"
                                    :key="key"
                                    @click.native="$i18n.locale = key">{{ val._lang }}</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </el-menu-item>
          </el-menu>
        </div>
        <div class="search"
             v-show="false">
          <svg aria-hidden="true"
               class="icon-svg">
            <use xlink:href="#icon-search" />
          </svg>
        </div>
        <div class="goLogin"
             @click="b2bGoLogin"
             v-if="!hasLogin">
          <svg aria-hidden="true"
               class="icon-svg">
            <use xlink:href="#icon-user" />
          </svg>
          {{$t('headerMenu.login')}}
        </div>
        <div class="goLogin" id="devLogin"
             @click="goLogin"
             v-show="isProd"
             v-if="!hasLogin" style="font-size: 10pt;">
          / 开发者登录
        </div>
        <!-- <div class="goRegister"
                     v-if="!hasLogin">
                  {{$t('headerMenu.register')}}
        </div>-->
        <!-- 消息通知 -->
        <el-tooltip v-if="hasLogin"
                    class="item"
                    effect="dark"
                    placement="bottom">
          <div slot="content">{{$t('protaLogin.notify')}}</div>
          <div class="task-upcoming"
               @click="goNotify()">
            <div class="task-count"
                 v-if="notifyCount>0">
              {{notifyCount}}
            </div>
            <!-- icon-mail -->
            <!-- icon-notification -->
            <svg data-v-511f72fd=""
                 aria-hidden="true"
                 class="icon-svg">
              <use data-v-511f72fd=""
                   xlink:href="#icon-mail"></use>
            </svg>
          </div>
        </el-tooltip>
        <el-tooltip v-if="hasLogin"
                    class="item"
                    effect="dark"
                    placement="bottom">
          <div slot="content">{{$t('protaLogin.upcoming')}}</div>
          <div class="task-upcoming"
               @click="goTask()">
            <div class="task-count"
                 v-if="99>taskCount>0">{{taskCount}}</div>
                 <div class="task-count"
                 v-else-if="taskCount>99">99+</div>
            <svg data-v-511f72fd
                 aria-hidden="true"
                 class="icon-svg">
              <use data-v-511f72fd
                   xlink:href="#icon-edit-square" />
            </svg>
          </div>
        </el-tooltip>

        <el-dropdown v-if="hasLogin"
                     placement="bottom"
                     :show-timeout="0">
          <div class="userData">
            <img alt="" :src="userImg"
                 v-if="userImg && userImg !== ''" />
            <img alt="" src="@/assets/img/home/user_img.png"
                 v-else />
          </div>
          <el-dropdown-menu slot="dropdown">
            <!-- <el-dropdown-item @click.native="goPerson()">{{ $t('headerLogin.mine') }}</el-dropdown-item> -->
            <!-- <el-dropdown-item @click.native="modifyPassword()">{{ $t('protaLogin.modifyPassword') }}</el-dropdown-item> -->
            <el-dropdown-item @click.native="account()"
                              style="padding:0">{{ $t('headerLogin.account') }}</el-dropdown-item>
            <el-dropdown-item @click.native="resume()"
                              style="padding:0">{{ $t('headerLogin.resume') }}</el-dropdown-item>
            <el-dropdown-item @click.native="logOut()">{{ $t('headerLogin.logout') }}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <!-- <div v-if="hasLogin"
                     class="logout"
                     @click="logOut()">
                  {{ $t('headerLogin.logout') }}
        </div>-->
        <iframe  v-if="adminLogoutState" name="logoutAdminIFrame" id="logoutAdminIFrame"
                :src="logoutAdminUrl()"
                width='0'
                height='0'
                frameborder="0"
                title=""
                >
        </iframe>
      </div>


    </div>
    <div class="hide-menu" v-show="false">
         <!-- v-show="hasLogin && !quickMenuShow"> -->
      <svg data-v-511f72fd
           @click="toggleMenu()"
           aria-hidden="true"
           class="icon-svg">
        <use data-v-511f72fd
             xlink:href="#icon-down-circle" />
      </svg>
    </div>
    <div class="quick-menu" v-show="false">
         <!-- v-show="hasLogin && quickMenuShow"> -->
      <div class="option-div">
        <svg data-v-511f72fd
             v-show="quickMenuShow"
             @click="toggleMenu()"
             aria-hidden="true"
             class="icon-svg">
          <use data-v-511f72fd
               xlink:href="#icon-up-circle" />
        </svg>

        <svg data-v-511f72fd
             @click="showEditMenu()"
             aria-hidden="true"
             class="icon-svg">
          <use data-v-511f72fd
               xlink:href="#icon-setting" />
        </svg>
      </div>
      <div class="each-menu"
           v-for="(item,index) in quickMenuList"
           :key="item.quickMenuUrl"
           @click="goQuickMenu(item)"
           :class="[colorList[index],{radix:index%2!=0 , noTop:index>1}]">
        <svg v-show="showEditFlag"
             @click="deleteQuickMenu(item.quickMenuId)"
             data-v-511f72fd
             aria-hidden="true"
             class="icon-svg">
          <use data-v-511f72fd
               xlink:href="#icon-close-circle" />
        </svg>
        {{item.quickMenuName}}
      </div>
    </div>
    <div class="main-tip"
         v-show="false">
      <div class="xiaobao">
        <div class="xiaobao-img">
          <img alt="" src="../../assets/img/uimg2.jpg" />
        </div>
        <div class="xiaobao-txt">{{$t('headerMenu.xiaobao')}}</div>
      </div>
      <div class="go-top"
           @click="goTop">
        <svg aria-hidden="true"
             class="icon-svg">
          <use xlink:href="#icon-arrowup" />
        </svg>
      </div>
    </div>

    <iframe
        name="loginAdminIFrameHeaderPage"
        id="loginAdminIFrameHeaderPage"
        src="javascript:void(0)"
        width="0"
        height="0"
        frameborder="0"
        title=""
    >
    </iframe>
    <form
        action="#"
        method="post"
        target="loginAdminIFrameHeaderPage"
        name="adminLoginFormHeaderPage"
        id="adminLoginFormHeaderPage"
        enctype="application/x-www-form-urlencoded"
    >
      <input type="hidden" id="loginAdminTokenHeaderPage" name="access_token" value="" />
    </form>

  </div>
</template>

<script>
import Vue from 'vue'
import { messages } from '@/i18n'
import $ from 'jquery'
// import Cookies from 'js-cookie'
import { clearLoginInfo } from '@/utils'
import AesUtil from "@/utils/aes_utils";
// import { clearLoginInfo } from '@/utils'
import axios from 'axios'

const protalList = [
  { name: '/' },
  { name: '/protalMain' },
  { name: '/register' },
  { name: '/forgetPassword' },
  { name: '/person' }
]
export default {
  data() {
    return {
      i18nMessages: messages,
      logoutState: false,
      adminLogoutState: false,
      // tab菜单选项
      tabs: [],
      dataList: [
        // 首页
        {
          dictName: 'person',
          title: 'headerMenu.main',
          color: 'grey'
        },
        // 资讯
        {
          dictName: 'information',
          title: 'headerMenu.information',
          color: 'yellow'
        },
        // 加入BEST
        {
          dictName: 'addBEST',
          title: 'headerMenu.addBEST',
          color: 'blue'
        },
        // 加入BMW经销商
        {
          dictName: 'addBMW',
          title: 'headerMenu.addBMW',
          color: 'orange'
        },
        // 学院视界
        {
          dictName: 'academicHorizon',
          title: 'headerMenu.academicHorizon',
          color: 'green'
        }

        // 系统管理
        // {
        //   name: 'manageMain',
        //   title: 'headerMenu.manage',
        //   color: 'brown'
        // }
      ],
      manageBtn: {
        name: 'manageMain'
      },
      hasLogin: false,
      tabName: 'protalMain',
      // 待办任务数量
      taskCount: 0,
      colorList: ['grey', 'yellow', 'blue', 'green', 'orange', 'brown', 'grey'],
      loginMenu: [],
      quickMenuList: [],
      quickMenuShow: false,
      showEditFlag: false,
      userImg: null,
      // 消息通知数量
      notifyCount: 0,
    }
  },
  computed: {
    isProd: function () {
      let envVal = process.env.VUE_APP_NODE_ENV
      if (envVal === 'prod') {
        return false
      } else {
        return true
      }
    }
  },
  components: {},
  created() {
    if(this.getStorage(this.GLOBAL.DIALOG_VISIBLE)){
               this.logOutNew()
    }
    this.tabs = this.getFilterTabs();
    if (this.getStorage(this.GLOBAL.USER_DATA)) {
      this.userData = this.getStorage(this.GLOBAL.USER_DATA)
    }
    if (this.getStorage(this.GLOBAL.TOKEN)) {
      this.hasLogin = true
      this.adminLogoutState = false
      this.getTaskCount()
      this.getNotifyCount()
    }
    // 广播接收head-login画面
    this.$eventHub.$on(this.GLOBAL.USER_DATA, data => {
      this.userData = data
      this.hasLogin = true
      this.adminLogoutState = false
      if (this.getStorage(this.GLOBAL.USER_DATA)) {
        this.userData = this.getStorage(this.GLOBAL.USER_DATA)
      }
      this.getTaskCount()
      this.getNotifyCount()
      this.$nextTick(function () {
        this.getCodeMenuList()
      })
    })
    // 广播接收待办审批
    this.$eventHub.$on(this.GLOBAL.TODO_TASK, data => {
      this.getTaskCount()
    })
    // 广播接收head-login画面 登录信息
    this.$eventHub.$on(this.GLOBAL.LOGOUT, data => {
      // eslint-disable-next-line no-debugger
      // debugger
      this.quickMenuList = []
      this.quickMenuShow = false
      this.hasLogin = false
      this.taskCount = 0
    })
    // 广播接收页面名
    this.$eventHub.$on(this.GLOBAL.ROUTER_NAME, data => {
      this.tabName = data
    })
    // 广播接收自定义菜单
    this.$eventHub.$on(this.GLOBAL.QUICK_MENU, data => {
      this.getQuickMenuList()
      this.showEditFlag = false
    })
    this.$eventHub.$on(this.GLOBAL.HEADER_IMG, data => {
      this.userImg = null
      this.getUserimg()
    })
    // 广播接收消息通知提醒
    this.$eventHub.$on(this.GLOBAL.TODO_NOTIFY, (data) => {
      this.getNotifyCount()
    })
  },
  watch: {
    $route(to, from) {
    if(to||from){
      if(this.getStorage(this.GLOBAL.DIALOG_VISIBLE)){
         this.logOutNew()
    }
    }
    }
  },
  mounted() {
    if (JSON.stringify(this.getStorage('clickTab')) !== '{}') {
      if (this.getStorage('clickTab')) {
        this.getNav(this.getStorage('clickTab'))
      }
    }
    this.$eventHub.$emit(this.GLOBAL.MENU_LIST)
    if (this.getStorage(this.GLOBAL.USER_DATA)) {
      this.userData = this.getStorage(this.GLOBAL.USER_DATA)
    }
    if (this.userData && this.userData.userId) {
      this.getCodeMenuList()
      this.getQuickMenuList()
      this.showEditFlag = false
    }
    // 获取当前路由路径
    let index = window.location.href.indexOf('#')
    let routePath = window.location.href.substring(index + 1)
    let hasProtal = false
    //如果是在线学习,拦截后直接跳转到登录页面
    let url = window.location.href
    if(url.indexOf('app-online-study')>-1){
      let token = window.SITE_CONFIG['userData'].accessToken
      if(token==undefined){
        // this.goLogin()
        this.$router.replace({ name: 'manageMain' })
        this.tabName = '后台管理'
      }
    }
    // 判断是否是门户页面
    hasProtal = protalList.some(item => {
      return item.name === routePath
    })
    if (!hasProtal) {
      this.tabName = '后台管理'
    } else {
      this.tabName = routePath.replace('/', '')
    }
    this.getUserimg()

    window.addEventListener('message',e=>{
      let domainReg = new RegExp("bmw.com.cn")
      if(domainReg.test(e.origin)){
        console.log(e.origin)
        console.log(e.data)
        if (e.data == 'AdminLoginSuccess') {
          sessionStorage.setItem('AdminLoginStatus', '1')
        }
      }
    }, false)

    let retryTimes =  120
    let retryCount = 0
    setInterval(function(){
      let adminLoginStatus = sessionStorage.getItem('AdminLoginStatus')
      let loginCommToken = sessionStorage.getItem('loginCommToken')
      if (loginCommToken != null && adminLoginStatus == null){

        let adminUrl = window.SITE_CONFIG["AdminURL"]
        if (adminUrl != null){
          if (retryCount <= retryTimes){
            retryCount++

            let tokenUrl = window.SITE_CONFIG["AdminURL"] + "/main?menu_url=/page/resource/classifyList"
            console.log(tokenUrl)
            document.getElementById("loginAdminTokenHeaderPage").value = window.SITE_CONFIG['userData'].accessToken || sessionStorage.getItem('loginCommToken');
            document.getElementById("adminLoginFormHeaderPage").action = tokenUrl;
            document.getElementById("adminLoginFormHeaderPage").submit();
          }

        }


      }
    }, 3000)
  },
  methods: {
    getNav(item) {
      this.$request
        .get('/sys/menu/nav', {
          sysCode: item.dictValue
        })
        .then(res => {
          var sysMenuSwitch = window.SITE_CONFIG['sysMenuSwitch']
          var sysMenuSwitchOld = window.SITE_CONFIG['sysMenuSwitchOld']
          if(sysMenuSwitch !== undefined && sysMenuSwitch.length > 0 && sysMenuSwitch.indexOf(item.dictName) >0){

            console.log('getNav')
            console.log(sysMenuSwitchOld[sysMenuSwitch.indexOf(item.dictName)])
            this.setStorage('clickTab', item)
            this.$router.push({ name: 'sys-maintain-maintainInfo',query:{menu:sysMenuSwitchOld[sysMenuSwitch.indexOf(item.dictName)]} })
            window.SITE_CONFIG['menuList'] = []
            this.$eventHub.$emit(this.GLOBAL.MENU_LIST)
            // 通知首页变更
            this.$eventHub.$emit(this.GLOBAL.HOME)
          }else {
            window.SITE_CONFIG['menuList'] = res
            this.$eventHub.$emit(this.GLOBAL.MENU_LIST)
            this.tabName = item.dictName
          }

        })
        .catch((err) => {
          console.log(err)
        })
    },
    // 获取头像
    getUserimg() {
      this.dataForm = this.getStorage(this.GLOBAL.USER_DATA)
      if (
        this.dataForm &&
        this.dataForm.headurl !== '' &&
        this.dataForm.headurl !== null &&
        this.dataForm.headurl !== undefined
      ) {
        this.userImg = this.dataForm.headurl
      }
      // else {
      //   this.userImg = "@/assets/img/home/user_img.jpg"
      // }
    },
    deleteQuickMenu(id) {
      const base64url = require('base64-url')
      let aes = new AesUtil()
      let userId = base64url.encode(aes.encrypt(this.userData.userId + ''))
      this.$request
        .post('/sys/commquickmenu/deleteMT', {
          userId: userId,
          quickMenuId: id
        })
        .then(res => {
          this.getQuickMenuList()
        })
        .catch((err) => {
          console.error(err)
        })
    },
    // TODO
    goQuickMenu(item) {
      if (this.showEditFlag) {
        return false
      }
      let oldItem = this.getStorage('clickTab')
      if (oldItem && oldItem.dictValue === item.sysCode) {
        this.$router.replace({ path: item.quickMenuUrl })
      }
        else {
        this.$store.state.contentTabs = this.$store.state.contentTabs.filter(item => item.name === 'home')
        if (this.$route.path.indexOf('home') < 0) {
          this.$router.replace({ name: 'home' })
        }
        if (item.sysCode === '10') { //系统管理
          let newItem = {
            dictNameCn: "系统管理",
            dictValue: "10",
            dictNameEn: "General purpose subsystem",
            updateUser: 1,
            pid: 264,
            sort: 7,
            delFlag: "0",
            dictType: "sysCode",
            createUser: 1,
            dictName: "系统管理",
            id: 265
          }
          this.setStorage('clickTab', newItem)
          this.tabName = newItem.dictName
          this.$request.get('/sys/menu/nav', {
            sysCode: newItem.dictValue
          }).then(res => {
            window.SITE_CONFIG['menuList'] = res
            this.$eventHub.$emit(this.GLOBAL.MENU_LIST)
            this.$router.replace({ path: item.quickMenuUrl })
          }).catch((err) => {
            console.log(err)
          })
        } else if (item.sysCode === '40') { //报表管理
          let newItem = {
            dictNameCn: "报表管理",
            dictValue: "40",
            dictNameEn: "Report Management",
            updateUser: 1,
            pid: 264,
            sort: 6,
            delFlag: "0",
            dictType: "sysCode",
            createUser: 1,
            dictName: "报表管理",
            id: 367
          }
          this.setStorage('clickTab', newItem)
          this.tabName = newItem.dictName
          this.$request.get('/sys/menu/nav', {
            sysCode: newItem.dictValue
          }).then(res => {
            window.SITE_CONFIG['menuList'] = res
            this.$eventHub.$emit(this.GLOBAL.MENU_LIST)
            this.$router.replace({ path: item.quickMenuUrl })
          }).catch((err) => {
            console.log(err)
          })
        } else if (item.sysCode === '30') { //人才发展
          let newItem = {
            dictNameCn: "人才发展",
            dictValue: "30",
            dictNameEn: "Personnel Development",
            updateUser: 1,
            pid: 264,
            sort: 5,
            delFlag: "0",
            dictType: "sysCode",
            createUser: 1,
            dictName: "人才发展",
            id: 366
          }
          this.setStorage('clickTab', newItem)
          this.tabName = newItem.dictName
          this.$request.get('/sys/menu/nav', {
            sysCode: newItem.dictValue
          }).then(res => {
            window.SITE_CONFIG['menuList'] = res
            this.$eventHub.$emit(this.GLOBAL.MENU_LIST)
            this.$router.replace({ path: item.quickMenuUrl })
          }).catch((err) => {
            console.log(err)
          })
        } else if (item.sysCode === '50') { //资源管理
          let newItem = {
            dictNameCn: "资源管理",
            dictValue: "50",
            dictNameEn: "Resource Management",
            updateUser: 1,
            pid: 264,
            sort: 4,
            delFlag: "0",
            dictType: "sysCode",
            createUser: 1,
            dictName: "资源管理",
            id: 368
          }
          this.setStorage('clickTab', newItem)
          this.tabName = newItem.dictName
          this.$request.get('/sys/menu/nav', {
            sysCode: newItem.dictValue
          }).then(res => {
            window.SITE_CONFIG['menuList'] = res
            this.$eventHub.$emit(this.GLOBAL.MENU_LIST)
            this.$router.replace({ path: item.quickMenuUrl })
          }).catch((err) => {
            console.log(err)
          })
        } else if (item.sysCode === '20') { //学习管理
          let newItem = {
            dictNameCn: "学习管理",
            dictValue: "20",
            dictNameEn: "Vehicle subsystem",
            updateUser: 1,
            pid: 264,
            sort: 3,
            delFlag: "0",
            dictType: "sysCode",
            createUser: 1,
            dictName: "学习管理",
            id: 266
          }
          this.setStorage('clickTab', newItem)
          this.tabName = newItem.dictName
          this.$request.get('/sys/menu/nav', {
            sysCode: newItem.dictValue
          }).then(res => {
            window.SITE_CONFIG['menuList'] = res
            this.$eventHub.$emit(this.GLOBAL.MENU_LIST)
            this.$router.replace({ path: item.quickMenuUrl })
          }).catch((err) => {
            console.log(err)
          })
        }
      }
    },
    showEditMenu() {
      this.showEditFlag = !this.showEditFlag
    },
    toggleMenu() {
      this.showEditFlag = false
      if (this.quickMenuList.length === 0) {
        this.quickMenuShow = false
        return false
      }
      this.quickMenuShow = !this.quickMenuShow
    },
    getQuickMenuList() {
      this.$request
        .get(`/sys/commquickmenu/info/${this.userData.userId}`)
        .then(res => {
          this.quickMenuList = res
          if (this.quickMenuList.length > 0) {
            this.quickMenuShow = true
          } else {
            this.quickMenuShow = false
          }
        })
        .then(() => { })
        .catch(() => { })
    },
    getCodeMenuList() {
      const base64url = require('base64-url')
      let aes = new AesUtil()
      let userId = base64url.encode(aes.encrypt(this.userData.userId + ''))
      this.$request
        .get('/sys/menu/selectSysCodeMenuListMT', {
          userId: userId
        })
        .then(res => {
          // 拼接个人首页
          var menuList = [
            {
              dictNameCn: '首页',
              dictValue: '70',
              dictNameEn: 'PERSONAL HOME PAGE',
              updateUser: 1,
              pid: 264,
              remark: null,
              updateTime: '2019-06-07 00:00:00',
              sort: 0,
              delFlag: '0',
              dictType: 'sysCode',
              createTime: '2019-06-07 00:00:00',
              createUser: 1,
              dictName: '首页',
              id: 9999
            }
            ,
            {
              dictNameCn: "在线学习",
              dictValue: "60",
              dictNameEn: "Study Scope",
              updateUser: 1,
              pid: 264,
              remark: null,
              updateTime: "2019-06-07 00:00:00",
              sort: 2,
              delFlag: "0",
              dictType: "sysCode",
              createTime: "2019-06-07 00:00:00",
              createUser: 1,
              dictName: "在线学习",
              id: 369
            }
          ]
          let index = res.findIndex(d => {
            return d.dictName === '在线学习'
          })

          if (index > -1) {
            res.splice(index, 1)
          }
          res.forEach(element => {
            if (element.dictValue != '60') {
              menuList.push(element)
            }
          })
          // res.forEach(element => {
          //    menuList.push(element)
          // })
          this.loginMenu = menuList
          this.$nextTick(() => {
            this.tabName = '个人首页'
          })
        })
        .then(() => { })
        .catch(() => { })
    },
    // 跳转到个人
    goPerson() {
      this.$router.replace({ name: 'person' })
      this.tabName = '个人首页'
    },
    // 获取待办任务数量
    getTaskCount() {
      const base64url = require('base64-url')
      let aes = new AesUtil()
      let userId = base64url.encode(aes.encrypt(this.userData.userId + ''))
      if (this.userData && this.userData.userId && !this.getStorage("taskCount")) {
        this.$request
          .getAct('/act/operate/taskCountMT', {
            userId: userId
          })
          .then(res => {
            this.taskCount = res
			this.setStorage("taskCount",this.taskCount);
          })
          .catch((err) => {
            console.log(err)
          })
      }else {
		  this.taskCount = this.getStorage("taskCount");
	  }
    },
    // tab页切换
    goTab(item, self) {
      if (item.dictName==='addBMW'){
        window.open('https://bmwdealer.zhaopin.com',"_blank");
        return false
      }

      console.log('goTab')
      console.log(window.SITE_CONFIG['sysMenuSwitch'])

      let oldItem = this.getStorage('clickTab')
      console.log(oldItem)
      console.log(item)
      var sysMenuSwitch = window.SITE_CONFIG['sysMenuSwitch']
      var sysMenuSwitchOld = window.SITE_CONFIG['sysMenuSwitchOld']
      if(sysMenuSwitch !== undefined && sysMenuSwitch.length > 0 && sysMenuSwitch.indexOf(item.dictName) >0){
        this.setStorage('clickTab', item)

        this.$router.push({ name: 'sys-maintain-maintainInfo',query:{menu:sysMenuSwitchOld[sysMenuSwitch.indexOf(item.dictName)]} })
        window.SITE_CONFIG['menuList'] = []
        this.$eventHub.$emit(this.GLOBAL.MENU_LIST)
        // 通知首页变更
        this.$eventHub.$emit(this.GLOBAL.HOME)
      }else  if (oldItem && oldItem.dictName === item.dictName && this.hasLogin) {
        if (item.dictValue === '70') { // 首页
          this.$router.replace({ name: 'person' })
        }
        //  else if (item.dictValue === '60') { // 在线学习
        //   this.$router.replace({ name: 'online-study' })
        // }

        else {
          this.$router.push({ name: 'home' })
        }
      } else {
        this.setStorage('clickTab', item)
        this.tabName = item.dictName
        if (item.dictValue) {
          if (item.dictValue === '70') { // 首页
            this.$router.replace({ name: 'person' })
            return false
          }
          // else if (item.dictValue === '60') { // 在线学习
          //   this.$router.replace({ name: 'online-study' })
          //   return false
          // }
          // 获取菜单列表, 添加并全局变量保存
          this.$request.get('/sys/menu/nav', {
            sysCode: item.dictValue
          }).then(res => {
            window.SITE_CONFIG['menuList'] = res
            this.$eventHub.$emit(this.GLOBAL.MENU_LIST)
            this.$store.state.contentTabs = this.$store.state.contentTabs.filter(item => item.name === 'home')
            if (this.$route.path.indexOf('home') < 0) {
              this.$router.replace({ name: 'home' })
            }
            // 通知首页变更
            this.$eventHub.$emit(this.GLOBAL.HOME)
          })
            .catch((err) => {
              console.log(err)
            })
        } else {
          if (this.tabName === 'person') {
            if (this.hasLogin) {
              this.$router.replace({ name: this.tabName })
            } else {
              this.$router.replace({ name: 'protalMain' })
            }

          } else {
            this.$router.replace({ name: item.dictName })
          }


        }

      }
    },
    // 首页
    goMain() {
      this.$router.replace({ name: 'protalMain' })
    },
    // 跳转到待办任务
    goTask() {
      let oldItem = this.getStorage('clickTab')
      if (oldItem && oldItem.dictName === '系统管理') {
        this.$router.push({ name: 'activiti-task-upcoming' })
      } else {
        this.$store.state.contentTabs = this.$store.state.contentTabs.filter(item => item.name === 'home')
        if (this.$route.path.indexOf('home') < 0) {
          this.$router.replace({ name: 'home' })
        }
        let item = {
          dictNameCn: "系统管理",
          dictValue: "10",
          dictNameEn: "General purpose subsystem",
          updateUser: 1,
          pid: 264,
          sort: 7,
          delFlag: "0",
          dictType: "sysCode",
          createUser: 1,
          dictName: "系统管理",
          id: 265,
          router: 'upcoming'
        }
        this.setStorage('clickTab', item)
        this.tabName = item.dictName
        this.$request.get('/sys/menu/nav', {
          sysCode: item.dictValue
        }).then(res => {
          window.SITE_CONFIG['menuList'] = res
          this.$eventHub.$emit(this.GLOBAL.MENU_LIST)
          this.$router.push({ name: 'activiti-task-upcoming' })
        }).catch((err) => {
          console.log(err)
        })
      }
    },
    // 点击登录
    goLogin() {
      this.$router.replace({ name: 'manageMain' })
      this.tabName = '后台管理'
    },
    b2bGoLogin() {
      window.location.href = window.SITE_CONFIG['apiURL'] + '/auth/didLogin'
    },
    logOut() {
      let _this = this
      this.$confirm(
        this.$t('prompt.info', { handle: this.$t('logout') }),
        this.$t('prompt.title'),
        {
          confirmButtonText: this.$t('confirm'),
          cancelButtonText: this.$t('cancel')
        }
      )
        .then(() => {
          console.log('logout call')

          _this.adminLogoutState = true


          _this.$request
            .post('/auth/logoutIam', {userId: this.userData.userId} )
            .then(res => {
              clearLoginInfo()
              _this.hasLogin = false
              // 广播通知main画面
              this.setStorage('logout_state', 1)
              _this.$eventHub.$emit(this.GLOBAL.LOGOUT, res)
              _this.$router.push({ name: 'protalMain' })
              this.tabName = '后台管理'
              //OauthLog退出
              let oauthLoginPath = window.SITE_CONFIG['oauthURL']
              let oauthLogoutPath = oauthLoginPath.replace('/login','/logout')
              //将OauthLog accessToken清空
              window.SITE_CONFIG['userData'].accessToken = null
              axios.get(oauthLogoutPath)
              sessionStorage.clear('holiday')
            })
            .catch((err) => {
              console.log(err)
            })
        })
        .catch((err) => {
          console.log(err)
        })
    },
    logOutNew(){
      let _this = this
          _this.adminLogoutState = true
          _this.$request
            .post('/auth/logoutIam', {userId: this.userData.userId} )
            .then(res => {
              clearLoginInfo()
              _this.hasLogin = false
              // 广播通知main画面
              this.setStorage('logout_state', 1)
              _this.$eventHub.$emit(this.GLOBAL.LOGOUT, res)
              _this.$router.push({ name: 'protalMain' })
              this.tabName = '后台管理'
              //OauthLog退出
              let oauthLoginPath = window.SITE_CONFIG['oauthURL']
              let oauthLogoutPath = oauthLoginPath.replace('/login','/logout')
              //将OauthLog accessToken清空
              window.SITE_CONFIG['userData'].accessToken = null
              axios.get(oauthLogoutPath)
              sessionStorage.clear('holiday')
            })
            .catch((err) => {
              console.log(err)
            })
        .catch((err) => {
          console.log(err)
        })
    },
    // 返回顶部
    goTop() {
      $('body,html').animate({ scrollTop: 0 }, 500)
    },
    /**
     * 修改密码
     */
    modifyPassword() {
      this.$router.push({ name: 'modifyPassword' })
    },
    account() {
      this.$router.push({ name: 'account' })
    },
    resume() {
      console.log("resume")
      this.$router.push({path: '/resume'});
    },
    clearTimeout() {
      //重新计时
      clearInterval(this.timeoutLogoutHandler)
      this.timeoutLogout()
    },
    // 跳转到消息通知
    goNotify () {
      this.$router.replace({ name: 'notify' })
      // this.$router.push({ name: 'notify' })
    },
    // 获取消息通知数量
    getNotifyCount () {
      console.log(this.userData)
      if (this.userData && this.userData.userId) {
        this.$request.get('/notify/notifyinfo/unReadNotifyCount',
                {
                  userId: this.userData.userId
                }).then((res) => {
          this.notifyCount = res
        }).catch((err) => {
          console.log(err)
        })
      }
    },

    logoutAdminUrl(){
      let adminUrl = window.SITE_CONFIG['joylearningAdminURL'] + '/logout'
      return adminUrl
    },
    getFilterTabs() {
      let accessWhitelistDs = Vue.prototype.getStorage(Vue.prototype.GLOBAL.ACCESS_WHITELIST_DS)
      if (accessWhitelistDs == null || accessWhitelistDs == undefined || accessWhitelistDs == '' || accessWhitelistDs == 'main') {
        return this.dataList
      }
      // return this.dataList.filter(item => {
      //   return item.dictName == 'person' || item.dictName == 'information'
      // })
      return this.dataList
    },
    checkKeydown(event) {
      if (event.button == 2) {
        document.getElementById('devLogin').style.display = 'block'
      }
    }
  }

}
</script>
<style lang="scss" scoped>
.header-view {
  height: 105px;
  background: #fff;
  font-size: 16px;
  color: #666;
  .header-tit{
    font-weight: bold;
    color: #262626;
    height: 14px;
    line-height: 50px;
    padding-left: 22px;
    span{
      color: #aaa38e;
    }
  }
  .border-div {
    position: absolute;
    background: #b1b1b1;
    width: 100%;
    height: 5px;
    margin-top: -5px;
  }
  .content-view {
     width: 1200px;
    margin: 0 auto;
    height: 105px;
    .logo-img {
      margin-top:4px;
      display: flex;
     justify-content: center;
     align-items: center;
     margin-left: 21px;
      cursor:pointer;
      position: absolute;
      z-index: 99;
      img {
        // width: 120px;
        height: 105px;
        margin-left: -20px;
      }
      .title{
        width: 100px;
height: 25px;
font-size: 18px;
font-family: PingFangSC-Medium, PingFang SC, sans-serif;
font-weight: 550;
color: #252628;
line-height: 25px;
white-space: nowrap;
margin-left: -12px;
      }
    }
    .tab-content {
      cursor: pointer;
    position: absolute;
    z-index: 2;
    display: flex;
    overflow: hidden;
    background: #fff;
    white-space: nowrap;
    padding-top: 28px;
    margin-left: 240px;
    }

    .each-tab:first-child {
      margin-left: 0;
    }
    .each-tab {
      float: left;
      cursor: pointer;
      font-size: 16px;
      color: #262626;
      padding: 20px 22px 0 22px;
      height: 48px;
      border-bottom: 2px solid #aaa38e;
      margin-left: 0px;
    }
    .each-tab.active {
      font-weight: bold;
      border-bottom:2px solid #1C69D4FF!important;
    }
    .each-tab.grey {
      border-color: #DFE0E2FF;
    }
    .each-tab.yellow {
      border-color: #DFE0E2FF;
    }
    .each-tab.blue {
      border-color: #DFE0E2FF;
    }
    .each-tab.green {
      border-color: #DFE0E2FF;
    }
    .each-tab.orange {
      border-color: #DFE0E2FF;
    }
    .each-tab.brown {
      border-color: #DFE0E2FF;
    }
    .search {
      float: left;
      margin-right: 20px;
      .icon-svg {
        font-size: 22px;
        margin-top: -3px;
      }
    }
    .el-dropdown {
      float: left;
    }
    .login {
      float: right;
      height: 105px;
      display: flex;
      overflow: hidden;
      font-size: 18px;
      cursor: pointer;
      align-items: center;
      padding: 14px 33px 0 0;
      .language {
        float: left;
        margin-right: 20px;
        border-right: 2px solid #979797;
        padding-right: 20px;
        z-index: 999;
        svg {
          font-size: 20px;
          vertical-align: bottom;
        }
      }
      .goLogin {
        color: #1c69d4;
        float: left;
        margin-right: 20px;
        .icon-svg {
          font-size: 22px;
          margin-top: -3px;
        }
      }
      .goRegister {
        float: left;
        border-left: 2px solid #979797;
        padding-left: 20px;
      }
      .userData {
        float: left;
        img {
          width: 36px;
          height: 36px;
          border-radius: 18px;
        }
      }
      .logout {
        float: left;
        margin-left: 20px;
        border-left: 2px solid #979797;
        padding-left: 20px;
      }
      .task-upcoming {
        position: relative;
        float: left;
        margin-right: 30px;
        svg {
          font-size: 22px;
        }
        .task-count {
          position: absolute;
          font-size: 12px;
          color: #fff;
          background: #e34d59;
          border-radius: 9px;
          min-width: 18px;
          height: 18px;
          display: flex;
          -webkit-box-align: center;
          align-items: center;
          padding: 0 5px 0 6px;
          right: -16px;
          top: -10px;
        }
      }
    }

    .each-menu {
      display: inline-block;
      margin-left: 20px;
      cursor: pointer;
    }
    .each-menu:first-child {
      margin-left: 0;
    }
    .each-menu.active {
      color: #1b69d4;
    }
  }
  .el-menu-item {
    height: auto;
    line-height: normal;
  }
  .el-menu-item.is-active {
    border: none !important;
    background: none !important;
  }
  .aui-navbar__menu .el-menu-item,
  .aui-navbar__menu .el-submenu > .el-submenu__title {
    padding: 0;
  }
  .hide-menu {
    position: fixed;
    z-index: 999;
    right: 20px;
    top: 30%;
    cursor: pointer;
    margin-top: 2px;
    margin-right: 4px;
    box-shadow: 0 0 5px #ccc;
    padding: 0 6px 5px;
    background: #fff;
    border-radius: 3px;
  }
  .quick-menu {
    position: fixed;
    z-index: 5;
    right: 20px;
    top: 30%;
    cursor: pointer;
    background: #fff;
    width: 160px;
    box-shadow: 0 0 5px #ccc;
    overflow: hidden;
    display: block;
    padding-bottom: 6px;
    .option-div {
      overflow: hidden;
      svg.icon-svg {
        float: right;
        margin: 4px 10px 0 0;
        cursor: pointer;
      }
    }
    .each-menu {
      font-size: 11px;
      text-align: center;
      padding: 0 8px;
      color: #fff;
      cursor: pointer;
      float: left;
      position: relative;
      width: 64px;
      margin: 10px;
      height: 36px;
      display: flex;
      align-items: center;
      svg.icon-svg {
        position: absolute;
        z-index: 9;
        right: -5px;
        top: -5px;
        cursor: pointer;
        color: #666;
        background: #fff;
        border-radius: 5px;
      }
      svg.icon-svg:hover {
        background: #ccc;
      }
    }
    .each-menu.radix {
      margin-left: 0;
    }
    .each-menu.noTop {
      margin-top: 0;
    }
    .each-menu.grey {
      background-color: #aaa38e;
    }
    .each-menu.yellow {
      background-color: #feca00;
    }
    .each-menu.blue {
      background-color: #92a2bd;
    }
    .each-menu.green {
      background-color: #a1ad01;
    }
    .each-menu.orange {
      background-color: #ff9000;
    }
    .each-menu.brown {
      background-color: brown;
    }
  }
  .main-tip {
    position: fixed;
    z-index: 999;
    right: 20px;
    top: 70%;
    cursor: pointer;
    display: block;
    .xiaobao {
      background: #ffffff;
      border: 1px solid #dddddd;
      border-radius: 2px;
      width: 86px;
      height: 86px;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      img {
        width: 50px;
      }
      .xiaobao-txt {
        color: #262626;
      }
    }
    .go-top {
      background: #ffffff;
      border: 1px solid #dddddd;
      border-radius: 2px;
      margin-top: 10px;
      width: 86px;
      height: 86px;
      display: flex;
      justify-content: center;
      align-items: center;
      svg {
        color: #262626;
        font-size: 30px;
      }
    }
  }
}

</style>
